import AddIcon from '@mui/icons-material/Add';
import { Button, Stack, TextField } from '@mui/material';
import { useDispatch } from 'react-redux';
import {
  useGetApiLocationsQuery,
  useGetApiProgramsQuery,
} from '../../../app/athenaApiGen';
import { openModal } from '../../../app/projects/projectsSlice';
import { PageTitle } from '../../../components/StyledComponents';
import { useProjectPermissions } from '../useProjectPermissions';

interface ProjectsToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
}

export default function ProjectsToolbar({
  search,
  onSearchChange,
}: ProjectsToolbarProps) {
  const { canCreateProject } = useProjectPermissions();
  const dispatch = useDispatch();

  // Pre-fetch programs and locations so the Create Project modal opens with a warm cache.
  useGetApiProgramsQuery();
  useGetApiLocationsQuery();

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-start"
      sx={{ mb: 2, mt: 2 }}
    >
      <Stack spacing={1}>
        <PageTitle>Projects</PageTitle>
        <TextField
          size="small"
          placeholder="Search projects…"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          sx={{ width: { xs: '100%', sm: 300 } }}
        />
      </Stack>
      {canCreateProject && (
        <Button
          size="small"
          variant="contained"
          startIcon={<AddIcon />}
          sx={{
            background: '#1F4D83',
            '&:hover': {
              background: '#163966',
            },
            color: (theme) => theme.palette.secondary.contrastText,
            textTransform: 'none',
          }}
          onClick={() => dispatch(openModal())}
        >
          Create Project
        </Button>
      )}
    </Stack>
  );
}
